export default __webpack_public_path__ + "static/mobil-b0feb7f026638d4f252380a90b66c040.svg";